import React from 'react';
import "react-toastify/dist/ReactToastify.css";
const Completed: React.FC = () => {

  return (
      <div className='space-y-4 flex grow'>
        <div className="px-8 pb-8 w-full flex flex-col">
          <div
              className="w-full lg:w-1/2 m-auto flex flex-col justify-center items-center p-4 text-green-800 border border-green-300 rounded-lg bg-green-50"
              role="alert">
            <svg className="inline w-16 h-16" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                 fill="currentColor" viewBox="0 0 20 20">
              <path
                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
            </svg>
            <h4 className="font-semibold text-2xl">Signup Success!</h4>
            <p className="text-center mt-2 text-fred-purple-500">Awesome! Thank you for signing up with FREDNET
              broadband. We have received your order. Our team will
              get back to you as soon as possible to complete your signup.</p>
            <button type="button"
                    onClick={() => {
                      window.location.replace('https://www.frednet.co.nz/');
                    }}
                    className="w-full md:w-1/5 mt-8 text-white bg-fred-purple-500 hover:bg-fred-blue-500 font-semibold rounded-lg text-base px-4 py-4 text-center inline-flex items-center justify-center cursor-pointer disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400">
              Continue
            </button>
          </div>
        </div>
      </div>
  );
};

export default Completed;
